import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ imageList: string }>()(
    (_, { imageList }) =>
        ({
            background: {
                backgroundImage: imageList,
                backgroundSize: 'cover',
                backgroundAttachment: 'fixed',
                backgroundPosition: '50% 50%',
                minHeight: '100vh',
            },
            topPlaceholder: {
                height: '65px',
            },
            box: {
                marginTop: 'calc(10% - 65px) !important',
                boxShadow: 'rgba(0,0,0,0.5) 0px 10px 10px 0',
                boxSizing: 'border-box',
                backgroundColor: 'rgb(43, 43, 47)',
                width: '400px',
                padding: '10px',
            },
            headerBlock: {
                padding: '30px 10px 10px',
            },
            header: {
                margin: '0 70px',
            },
            body: {
                padding: '10px',
            },

            // These styles are used in CentralBackground.tsx
            signInBox: {
                backgroundColor: 'rgb(29, 31, 35)',
                padding: '20px',
                marginTop: '6px',
            },
            logo: {
                color: 'white',
                height: '22px',
                width: '100%',
                '& path': {
                    fillOpacity: 1,
                },
            },
            text: {
                color: 'white',
                padding: '15px 0 10px',
                fontSize: '13px',
                wordBreak: 'break-word',
            },
        }) as const,
);
